letterAdjust.y = 2;
letterAdjust.x = 4;
letterAdjust.scale = .775;

var font_size = 25,
    panel_Hor_Adjustment = 3,
    font_Top_Adjustment = 0,
    tracking = 1,
    middleSplitAdjustment = -.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -267.5,
        horizontal: 0,
        scale_width: .18,
        scale_height: .18,
    },
    number_Adjustments = {
        top: -3,
        left: -5,
        width: 100,
        height: 90,
        middle_Space: 7,
        oneOffset: 6
    },
    colors = {
        characters: {
            athletic: [
                "#231F20", // black
            ],
            academic: [
                '#FFFFFF', // white
            ]
        },
        numbers: {
            athletic: [
                "#231F20", // black
                "#FFFFFF", // white
            ],
            academic: [
                '#FFFFFF', // white
            ]
        }
    },
    outlines = {
        characters: {
            width: 1.7
        },
        numbers: {
            width: 3
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 0.5, // this moves it up from the bottom
            horizontal: 1,
            scale_width: 15.5,
            scale_height: 15.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    };
